<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 安抚礼包 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px; display: flex">
          <div>
            <span style="font-size: 15px; margin-left: 20px">用户账号：</span>
            <el-input v-model="listQuery.account" placeholder="" style="width: 150px; margin-right: 20px"></el-input>
            <span>发送原因：</span>
            <el-select v-model="listQuery.code_purpose" filterable placeholder="请选择" style="margin-right: 20px">
              <el-option v-for="item in send_reason" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div style="float: right">
            <el-button class="filter-item" style="margin-left: 10px" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="warning" @click="reset">重置</el-button>
            <el-button class="filter-item" style="margin-left: 10px" type="success" @click="add">添加</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <el-table border v-loading="listLoading" :data="formData" min-height="200" max-height="1000">
          <el-table-column prop="account" label="用户账号 " />
          <el-table-column prop="mobile" label="手机号" width="150" />
          <el-table-column prop="verification_code" label="验证码" />
          <el-table-column prop="code_purpose" label="发送原因" />
          <el-table-column prop="admin_name" label="操作人" />
          <el-table-column prop="created_at" label="操作时间" />
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getGiftList" />
        <!-- 添家弹出框 -->
        <el-dialog title="添加" center="" :visible.sync="addshow" :close-on-click-modal="false" @close="cancel">
          <el-form :rules="rules" style="margin-left: 150px" label-position="left" :model="form" ref="form">
            <el-form-item label="用户账号" :label-width="formInputWidth" style="margin-top: 40px" prop="account">
              <el-col :span="10">
                <el-input v-model="form.account" placeholder="" @change="showTel"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formInputWidth" style="margin-top: 40px" prop="mobile">
              <el-col :span="10">
                <el-input v-model="form.mobile" type="tel" :disabled="isDisabled"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="发送原因" :label-width="formInputWidth" style="margin-top: 40px" prop="code_purpose">
              <el-col :span="10">
                <el-select v-model="form.code_purpose" filterable placeholder="请选择">
                  <el-option v-for="item in send_reason" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="sureAdd">确认</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>


<script>
import { getVerificationCodeList, getUserList, getVerificationCodeSelect, sendVerificationCode } from '@/api/gift_bag.js';
import Pagination from '@/components/pagination/index';
export default {
  components: { Pagination },
  name: 'send_verificationCode',
  data() {
    return {
      isDisabled: false,
      // 发送原因
      send_reason: [],
      rules: {
        account: [{ required: true, message: '请输入用户账号', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        code_purpose: [{ required: true, message: '请输入发送原因', trigger: 'blur' }],
      },
      // 搜索条件
      listQuery: {
        account: '',
        code_purpose: '',
        page: 1,
        limit: 20,
      },
      formData: [],
      form: {
        account: '',
        mobile: '',
        code_purpose: '',
        game_name: '',
        user_id: '',
      },
      listLoading: false,
      total: 0,
      formInputWidth: '170px',
      addshow: false,
    };
  },
  created() {
    this.getGiftList();
    this.getSelect();
  },
  methods: {
    // 获取验证码发送原因下拉框
    getSelect() {
      this.send_reason = [];
      getVerificationCodeSelect().then((res) => {
        res.data.data.forEach((item) => {
          const obj = { value: item, label: item };
          this.send_reason.push(obj);
        });
      });
    },
    // 根据账号显示电话号码
    showTel() {
      getUserList({ account: this.form.account }).then((res) => {
        if (res.data.code == 200) {
          this.form.mobile = res.data.data.mobile;
          this.form.user_id = res.data.data.user_id;
          this.form.game_name = res.data.data.game_name;
          console.log('mobile', this.form.mobile);
          if (this.form.mobile !== '') {
            this.isDisabled = true;
          }
        }
      });
    },
    add() {
      this.addshow = true;
      this.isDisabled = false;
    },
    cancel() {
      this.addshow = false;
      this.$refs.form.resetFields();
    },
    sureAdd() {
      sendVerificationCode(this.form).then((res) => {
        if (res.data.message == 'ok') {
          this.$message.success('添加成功');
          this.addshow = false;
          this.getGiftList();
        } else {
          this.$message.error('添加失败');
        }
      });
    },
    search() {
      this.listQuery.page = 1;
      console.log(this.listQuery);
      this.getGiftList();
    },
    reset() {
      this.listQuery.code_purpose = '';
      this.listQuery.account = '';
      this.listQuery.page = 1;
      this.listQuery.limit = 20;
      this.getGiftList();
    },
    getGiftList() {
      this.listLoading = true;
      getVerificationCodeList(this.listQuery)
        .then((res) => {
          this.formData = res.data.data.data;
          this.total = res.data.data.total;
          this.listLoading = false;
          this.$refs.form.resetFields();
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
  },
};
</script>


<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #f3f3f3;
  box-sizing: border-box;
}
.error-code {
  line-height: 1;
  font-size: 250px;
  font-weight: bolder;
  color: #f02d2d;
}
.error-code span {
  color: #00a854;
}
.error-desc {
  font-size: 30px;
  color: #777;
}
.error-handle {
  margin-top: 30px;
  padding-bottom: 200px;
}
.error-btn {
  margin-left: 100px;
}
</style>
